

export const filterProjectsByState = ( docs, state) =>  docs?.filter( project => project.estado === state );
